export default __webpack_public_path__ + "static/media/lugg.166617dd.png";